/**
 * Live upload row counts. Large files skip client-side row counting, so the
 * UI must show worker processedRows even before totalRows is known.
 */
function asCount(value) {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : 0;
}

export function formatUploadRowCount({ processedRows, totalRows } = {}) {
  const processed = asCount(processedRows);
  const total = asCount(totalRows);
  if (total && processed) {
    return `${processed.toLocaleString()} / ${total.toLocaleString()}`;
  }
  if (total) return total.toLocaleString();
  if (processed) return `${processed.toLocaleString()} processed`;
  return "—";
}

export function formatUploadProgressHint({
  processedRows,
  totalRows,
  message,
} = {}) {
  const processed = asCount(processedRows);
  const total = asCount(totalRows);
  const live = String(message || "").trim();
  if (total) {
    const pct = Math.min(100, Math.round((processed / total) * 100));
    return (
      live ||
      `Processing… ${processed.toLocaleString()} / ${total.toLocaleString()} (${pct}%)`
    );
  }
  if (processed) {
    return live || `Processing… ${processed.toLocaleString()} rows so far`;
  }
  return live;
}
